/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import { getTagsAll } from '../../services/tagsService';
import { useToast } from '../components/Toats';
import { TableTags } from './components/TableTags';

const tagsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const TagsUsinasPage: FC = () => {
    const { toggleToast } = useToast()
    const [tags, setTags] = useState<any>([]);
    const [tagsLoading, setTagsLoading] = useState<boolean>(true);
    const [filterName, setFilterName] = useState<string>("");

    const getTags = async () => {
        try {
          setTagsLoading(true)
          const myTags = await getTagsAll(filterName)
          setTags(Array.isArray(myTags) ? myTags : myTags?.data || [])

        } catch (error) {
          console.log(error)
          toggleToast("Erro ao buscar as tags!", "error")
        }finally{
          setTagsLoading(false)
        }
    }

    const refresh = () => {
      getTags()
    }

    useEffect(() => {
      getTags()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterName]);

  return (
    <div className='column g-5 g-xl-8'>
      <TableTags
        className='card-xl-stretch mb-xl-8'
        tags={tags}
        refresh={refresh}
        setFilterName={setFilterName}
        loading={tagsLoading}
      />
    </div>
  )
}

const TagsUsinasWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={tagsBreadcrumbs}>Tags de Usinas</PageTitle>
      <TagsUsinasPage />
    </>
  )
}

export {TagsUsinasWrapper}
